export const DEFAULT_PAGE_SIZE = 20;

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

/**
 * Normaliza cualquier respuesta del backend que siga el shape paginado estándar:
 * { success, data, total, page, limit, totalPages }
 */
export function normalizePaginatedResponse<T>(response: any): PaginatedResponse<T> {
  return {
    data: Array.isArray(response?.data) ? response.data : [],
    total: response?.total || 0,
    page: response?.page || 1,
    limit: response?.limit || DEFAULT_PAGE_SIZE,
    totalPages: response?.totalPages || 1,
  };
}

/**
 * Construye un query string desde un objeto, omitiendo valores undefined, null y ''.
 * Devuelve '' si no hay params (para no ensuciar la URL con '?').
 */
export function buildQueryString(params: Record<string, any>): string {
  const qs = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      qs.append(key, String(value));
    }
  });

  const str = qs.toString();
  return str ? `?${str}` : '';
}